import { FC } from 'react';

import Callout from 'components/_core/Callout';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';
import getBeneficiariesStep from 'features/Onboarding/common/getVerificationSteps/getBeneficiariesStep';
import getMultiKycStatus from 'features/Onboarding/common/useVerificationStatus/getMultiKycStatus';
import Header from 'features/Onboarding/components/Header';
import Page from 'features/Onboarding/legacy/components/Page';
import { OnboardingPageContent } from 'features/Onboarding/pageLayoutStyles';

import locales from './locales';
import { StepComponentProps } from './types';

const NextStepsAwaitingBeneficiaries: FC<StepComponentProps> = ({
  companyLegalBeneficiaries,
  companyName,
  isMandatee,
  onBeneficiariesClick,
}) => {
  if (companyLegalBeneficiaries === undefined) {
    throw new Error('companyLegalBeneficiaries must have loaded');
  }
  const multiKycStatusProperties = getMultiKycStatus({
    companyLegalBeneficiaries,
  });

  const mandateeLocaleKey = isMandatee ? 'mandatee' : 'nonMandatee';
  const beneficiariesStep = getBeneficiariesStep(multiKycStatusProperties);

  return (
    <Page withNoBackButton>
      <OnboardingPageContent>
        <Header
          imageHeightPx={90}
          imageWidthPx={90}
          title={
            locales.formatString(locales.awaitingBeneficiariesTitle, {
              companyName: companyName ?? '',
            }) as string
          }
        />

        <Text fontWeight="weight-500" marginBottom="space-8" variant="primary">
          {locales.beneficiaryWaitingTitle[mandateeLocaleKey]}
        </Text>
        <Text variant="secondary">
          {locales.beneficiaryWaitingText[mandateeLocaleKey]}
        </Text>

        <Callout marginTop="space-8">
          <Callout.Content>
            {locales.beneficiariesMailInfo[mandateeLocaleKey]}
          </Callout.Content>
        </Callout>

        <SunshineCard
          alignItems="center"
          marginTop="space-24"
          onClick={onBeneficiariesClick}
          title={beneficiariesStep.label}
        >
          <SunshineCard.Slot name="aside">
            {['complete', 'pending'].includes(beneficiariesStep.status) ? (
              <SquircleIcon colorScheme="green" name="tick" />
            ) : (
              <SquircleIcon name="team" />
            )}
          </SunshineCard.Slot>

          <SunshineCard.Content>
            <SunshineCard.Text>{beneficiariesStep.notes}</SunshineCard.Text>
          </SunshineCard.Content>

          <SunshineCard.Slot name="action">
            <SunshineCard.SunshineIcon name="chevron-right" />
          </SunshineCard.Slot>
        </SunshineCard>
      </OnboardingPageContent>
    </Page>
  );
};

export default NextStepsAwaitingBeneficiaries;
